<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-icon v-if="statusApi === 'AGENDADO'" color="#2196F3">flag</v-icon>
        <v-icon v-if="statusApi === 'EM_ANDAMENTO'" color="#2196F3">build</v-icon>
        <v-icon v-if="statusApi === 'FINALIZADO'" color="#4CAF50">check_circle</v-icon>
        <v-icon v-if="statusApi === 'CANCELADO'" color="#FFC107">remove_circle</v-icon>
      </div>
    </template>
    {{ statusNome }}
  </v-tooltip>
</template>

<script>

export default {
    nome: 'StatusAtendimentoIcone',
    props: {
        statusApi: {
            type: String,
            required: true
        },
        statusNome: {
            type: String,
            required: true
        },
    }
}

</script>

<style scoped lang="stylus">

</style>